const ACTIVE_CONTEXT_PREFIX = 'clerkActiveContext';
const CLIENT_UAT_PREFIX = 'clerkClientUat';

export function clearClerkClientCache() {
  if (typeof window === 'undefined') {
    return;
  }
  Object.keys(window.localStorage).forEach((key) => {
    if (
      key.startsWith(ACTIVE_CONTEXT_PREFIX) ||
      key.startsWith(CLIENT_UAT_PREFIX)
    ) {
      window.localStorage.removeItem(key);
    }
  });
}
